import React from 'react'
import { Link } from 'react-router-dom'
import SuperUserPageSF from './SuperUserPageSF'

const SuperUserAccountPageUI = ({ context, className, account, bankAccountNumber,
  topnav, backLink, headerText, subHeaderText,
  dimension, centered, children, page
}) =>
  <SuperUserPageSF
    context={context}
    className={className}
    topnav={topnav}
    backLink={backLink}
    headerText={headerText}
    subHeaderText={subHeaderText}
    dimension={dimension}
    centered={centered}
    children={children}
    account={account}
    sideBar={
      <SideBarUI
        page={page} account={account} bankAccountNumber={bankAccountNumber}
      />
    }
  />

const SideBarUI = ({ page, account, bankAccountNumber }) =>
  <div className='t_sidebar'>
    {
      account &&
      <>
        <SideBarItemUI label='KYC' to={`/su/accounts/${account.accountId}/kyc`} active={page === 'kyc'} />
        <SideBarItemUI label='Events' to={`/su/accounts/${account.accountId}/events`} active={page === 'events'} />
        <SideBarItemUI label='Event tracker' to={`/su/accounts/${account.accountId}/eventTracker`} active={page === 'eventTracker'} />
        <SideBarItemUI label='Onboarding tracker' to={`/su/accounts/${account.accountId}/onboardingTracker`} active={page === 'onboardingTracker'} />
        <SideBarItemUI label='Schedule VII Summary' to={`/su/accounts/${account.accountId}/schedukeVIISummary`} active={page === 'schedukeVIISummary'} />        <SideBarItemUI label='Loans in Account' to={`/su/accounts/${account.accountId}/loans`} active={page === 'loans'} />
        <SideBarItemUI label='Nach Failure' to={`/su/accounts/${account.accountId}/nachFailure`} active={page === 'nachFailure'} />
        <SideBarItemUI label='NACH Details' to={`/su/accounts/${account.accountId}/nach`} active={page === 'nach'} />
        <SideBarItemUI label='Config Notification' to={`/su/accounts/${account.accountId}/configNotification`} active={page === 'configNotification'} />
        <hr />
        <SideBarItemUI label='Onboarding Docs' to={`/su/accounts/${account.accountId}/onBoardingDocs`} active={page === 'onBoardingDocs'} />
        <SideBarItemUI label='Client Data' to={`/su/accounts/${account.accountId}/dataCollection`} active={page === 'clientData'} />
        <SideBarItemUI label='Bank Analyzer' to={`/su/accounts/${account.accountId}/clientTxnCats`} active={page === 'clientTxnCats'} />
        <SideBarItemUI label='Triangulation' to={`/su/accounts/${account.accountId}/triangulations`} active={page === 'triangulations'} />
        <SideBarItemUI label='Score Parameters' to={`/su/accounts/${account.accountId}/scoreParams`} active={page === 'scoreParams'} />
        <SideBarItemUI label='Score Card' to={`/su/accounts/${account.accountId}/scoreCard`} active={page === 'scoreCard'} />
        <SideBarItemUI label='2X Eligible' to={`/su/accounts/${account.accountId}/eligible2x`} active={page === 'eligible2x'} />
        <hr />
        <SideBarItemUI label='Customers' to={`/su/accounts/${account.accountId}/customers`} active={page === 'customers'} />
        <SideBarItemUI label='Customer Invoices' to={`/su/accounts/${account.accountId}/invoices`} active={page === 'invoices'} />
        {/* Hidden RF and Product Items as Bhawna mam required */}
        {/* <SideBarItemUI label='Receivable Financing' to={`/su/accounts/${account.accountId}/rf`} active={page === 'rf'} />
        <SideBarItemUI label='Product Items' to={`/su/accounts/${account.accountId}/productItems`} active={page === 'productItems'} /> */}
        <SideBarItemUI label='Vendors' to={`/su/accounts/${account.accountId}/vendors`} active={page === 'vendors'} />
        <SideBarItemUI label='Standing Instructions' to={`/su/accounts/${account.accountId}/recurringTransfers`} active={page === 'recurringTransfers'} />
        <hr />
        <SideBarItemUI label='Escrow Accounts' to={`/su/accounts/${account.accountId}/bankAccounts/${bankAccountNumber || ''}`} active={page === 'bank'} />
        <SideBarItemUI label='Transactions' to={`/su/accounts/${account.accountId}/txns3/${bankAccountNumber || ''}`} active={page === 'txns'} />
        {/* <SideBarItemUI label='Statements' to={`/su/accounts/${account.accountId}/statements`} active={page === 'statements'} /> */}
        <SideBarItemUI label='Cash Flow' to={`/su/accounts/${account.accountId}/cashFlow2`} active={page === 'cashFlow2'} />
        <SideBarItemUI label='Payment Approvals' to={`/su/accounts/${account.accountId}/payables`} active={page === 'payables'} />
        {
          account.escrowAccountNumber &&
          <SideBarItemUI label='Collection Account' to={`/su/accounts/${account.accountId}/txns/escrow/${account.escrowAccountNumber}`} active={page === 'escrow'} />
        }
        <hr />
        {/*<SideBarItemUI label='360&deg; View' to={`/su/accounts/${account.accountId}/360`} active={page === '360'} />*/}
        <SideBarItemUI label='Files' to={`/su/accounts/${account.accountId}/files`} active={page === 'files'} />
        <SideBarItemUI label='WhatsApp' to={`/su/accounts/${account.accountId}/chat`} active={page === 'chat'} />
        <SideBarItemUI label='WhatsApp Chat' to={`/su/accounts/${account.accountId}/whatsappChat`} active={page === 'whatsappChat'} />
        {/* <SideBarItemUI label='Receivable Financing' to={`/su/accounts/${account.accountId}/receivableFinancing`} active={page === 'receivableFinancing'} /> */}
        <SideBarItemUI label='Documents' to={`/su/accounts/${account.accountId}/documents`} active={page === 'documents'} />
        <SideBarItemUI label='Message Approvals' to={`/su/accounts/${account.accountId}/messageApprovals`} active={page === 'messageApprovals'} />
        <SideBarItemUI label='Journal Entries' to={`/su/accounts/${account.accountId}/journalEntries`} active={page === 'journalEntries'} />
        <SideBarItemUI label='SOA' to={`/su/accounts/${account.accountId}/soa`} active={page === 'soa'} />
      </>
    }
  </div>

const SideBarItemUI = ({ label, to, active }) =>
  <Link to={to} className={`${active ? 'active' : ''} t_sidebar_item`}>
    {label}
  </Link>

export default SuperUserAccountPageUI

